<template>
  <div>
    <FormulaireClient
      mode="edit"
      :client="client[0]"
      :provenance="provenance"
      v-if="client.length > 0"
    />
    <div v-else>Ce client n'existe pas.</div>
  </div>
</template>

<script>
import FormulaireClient from "./FormulaireClient";

export default {
  components: {
    FormulaireClient,
  },

  data() {
    return {
      provenance: "",
    };
  },

  computed: {
    client() {
      const id = this.$route.params.id;

      return this.$store.state.clients.filter((c) => c.id == id);
    },
  },

  mounted() {
    this.provenance = this.$route.params.provenance;
  },

  methods: {
    async getClient() {
      console.log("getclient");
    },
  },
};
</script>

